export enum AnimationType {
    BACKWARD,
    FORWARD,
    NONE
}

export const AnimationTypeValues = [
    AnimationType.BACKWARD,
    AnimationType.FORWARD,
    AnimationType.NONE,
]

export function getAnimationClass(type: AnimationType) {
    switch (type) {
        case AnimationType.BACKWARD:
            return "animate__animated animate__backInLeft"
        case AnimationType.FORWARD:
            return "animate__animated animate__backInRight";
        case AnimationType.NONE:
            return "";
    }
}